import { HTTP_CODES_COLORS_MAP, CHART_SERIES_COLOR_MAP } from 'constants/colorMaps'

export function colorizeResponseCodes (responseCodes) {
  if (!responseCodes) {
    return responseCodes
  }

  const countCodes = {}
  responseCodes.forEach(r => {
    const httpCodeGroup = r.name ? r.name[0] + 'xx' : ''
    const colors = HTTP_CODES_COLORS_MAP[httpCodeGroup]
    if (colors) {
      countCodes[httpCodeGroup] = (countCodes[httpCodeGroup] || 0) + 1
      const color = colors[(countCodes[httpCodeGroup] - 1) % colors.length]
      r.color = color
    }
    return r
  })

  return responseCodes
}

export function colorizeChartSeries (chartData) {
  if (!chartData) {
    return chartData
  }

  chartData.forEach(data => {
    const color = CHART_SERIES_COLOR_MAP[data.name]

    if (color) {
      data.color = color
    }
  })

  return chartData
}
